export default "__VITE_ASSET__d3872ceb__"